import { render, staticRenderFns } from "./GuildWelcome.vue?vue&type=template&id=1125e4a0&"
import script from "./GuildWelcome.vue?vue&type=script&lang=js&"
export * from "./GuildWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports